var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40459 18C0.707157 18 0.34901 17.5582 0.198213 17.2892C0.0474165 17.0203 -0.159929 16.4824 0.198213 15.8677L8.79362 0.71077C9.15176 0.0960419 9.69841 0 10 0C10.3016 0 10.8671 0.0960419 11.2064 0.71077L19.8018 15.8677C20.1599 16.4824 19.9526 17.0203 19.8018 17.2892C19.651 17.5582 19.2928 18 18.5954 18H1.40459Z",
    fill: "#FF5000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164 7.19287H8.90175L7.27051 10.6296L9.57345 11.585L8.06214 14.9687L12.764 10.3908L10.2931 9.71403L11.8164 7.19287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOrange);
export default __webpack_public_path__ + "static/media/warningOrange.377850a1826910772f9d7d370734fd67.svg";
export { ForwardRef as ReactComponent };